var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.show
    ? _c(
        "div",
        { staticClass: "info", attrs: { id: "renew-box" } },
        [
          _vm.$wf.isMdUp
            ? _c("span", {
                directives: [
                  {
                    name: "safe-html",
                    rawName: "v-safe-html",
                    value: _vm.daysLeftMsg,
                    expression: "daysLeftMsg",
                  },
                ],
              })
            : _vm._e(),
          _vm.$wf.isMdUp && !_vm.isEnterprise
            ? _c(
                "w-link",
                { staticClass: "mls mrs", attrs: { to: "/account/renew" } },
                [_c("b", [_vm._v(_vm._s(_vm.$ct("renew")))])]
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }